/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: hooks\useLicenseStatus.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Account Menu module.
────────────────────────────────────────────────────────────────*/


import { useState, useEffect, useCallback } from 'react';
import { getLicenseStatus, LicenseStatus } from '../api';

export function useLicenseStatus() {
    const [status, setStatus] = useState<LicenseStatus | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchStatus = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await getLicenseStatus();
            setStatus(data);
        } catch (err) {
            setError('Failed to load license status');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchStatus();
    }, [fetchStatus]);

    return { status, loading, error, refresh: fetchStatus };
}
